import { Sprite, Texture, interaction } from 'pixi.js';
import { UiContainer } from "./UiContainer";
import { ButtonAnimator } from "./ButtonAnimator";
import { InteractionEvents } from "./InteractionEvents";

/**
 */
export class Button extends Sprite {
  /**
   */
  public hidden: boolean;

  /**
   */
  public buttonAnimation?: ButtonAnimator;

  /**
   */
  public disablePixiUiOnTap: boolean = false;

  /**
   */
  constructor(texture?: Texture) {
    super(texture || Texture.EMPTY);
    this.interactive = true;
    this.buttonMode = true;
    this.visible = true;
  }

  /**
   * @param animator
   */
  public setAnimator(animator: ButtonAnimator) {
    animator.init(this);
    this.buttonAnimation = animator;
  }

  /**
   */
  public setVisible(visible?: boolean) {
    visible = typeof visible === "undefined" ? true : visible;
    if (visible !== this.hidden) {
      this.hidden = visible;
      if (this.hidden) this.transitionOut();
      else this.transitionIn();
    }
  }

  /**
   */
  public disableParentUiContainer() {
    let foundParentUiLayer = false,
      parent = this.parent;
    while (!foundParentUiLayer && parent) {
      foundParentUiLayer = parent instanceof UiContainer;
      if (foundParentUiLayer) parent.interactiveChildren = false;
      else parent = parent.parent;
    }
  }

  /**
   */
  public on(event: string, cb: (...args: any[]) => any, context?: any): this {
    switch (event) {
      case InteractionEvents.PointerTap:
        super.on(event, (e: interaction.InteractionEvent) => {
          this.requestFullscreen();
          if (this.disablePixiUiOnTap) this.disableParentUiContainer();
          if (this.buttonAnimation)
            this.buttonAnimation.play(this, cb.bind(context, e));
          else cb.call(context, e);
        });
        break;

      default:
        super.on(event, cb, context);
        break;
    }

    return this;
  }

  /**
   */
  public once(event: string, cb: (...args: any[]) => any, context?: any): this {
    switch (event) {
      case InteractionEvents.PointerTap:
        super.once(
          InteractionEvents.PointerTap,
          (e: interaction.InteractionEvent) => {
            this.requestFullscreen();
            if (this.disablePixiUiOnTap) this.disableParentUiContainer();
            if (this.buttonAnimation)
              this.buttonAnimation.play(this, cb.bind(context, e));
            else cb.call(context, e);
          }
        );
        break;

      default:
        super.once(event, cb, context);
        break;
    }

    return this;
  }

  /**
   */
  public transitionIn() {
    this.visible = true;
  }

  /**
   */
  public transitionOut() {
    this.visible = false;
  }

  /**
   */
  public animateCallToAction() {}

  /**
   */
  private requestFullscreen() {
    PIXI.utils.isMobile.any &&
      this.app &&
      this.app.buttonsRequestFullscreen &&
      this.app.resizer.requestFullscreen();
  }
}
